import AppliedApplications from 'Components/applications/AppliedApplications'
import CompletedApplications from 'Components/applications/CompletedApplications'
import OngoingApplications from 'Components/applications/OngoingApplications'
import useDocumentTitle from 'hooks/useDocumentTitle'
import React, { useEffect, useState } from 'react'
import classnames from 'classnames'
import { Container, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import 'Components/applications/style.scss'

type ApplicationTab = 'ongoing' | 'applied' | 'completed'

const Applications = () => {
    useDocumentTitle('Applications')
    const [activeTab, setActiveTab] = useState<ApplicationTab>('ongoing')

    return (
        <div className="page-content applications-page mb-3">
            <Container fluid>
                <div className="applications-page__header d-flex align-items-md-center justify-content-between flex-md-row flex-column mb-4 gap-3">
                    <h3 className="page-title m-0">Applications</h3>
                    <Nav
                        tabs
                        className="nav nav-tabs nav-tabs-custom nav-success applications-page__tabs mb-0"
                    >
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'ongoing' })}
                                style={{ cursor: 'pointer' }}
                                onClick={() => setActiveTab('ongoing')}
                            >
                                Ongoing
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'applied' })}
                                style={{ cursor: 'pointer' }}
                                onClick={() => setActiveTab('applied')}
                            >
                                Applied
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'completed' })}
                                style={{ cursor: 'pointer' }}
                                onClick={() => setActiveTab('completed')}
                            >
                                Completed
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>

                <TabContent activeTab={activeTab}>
                    <TabPane tabId="ongoing">
                        {activeTab === 'ongoing' && <OngoingApplications />}
                    </TabPane>
                    <TabPane tabId="applied">
                        {activeTab === 'applied' && <AppliedApplications />}
                    </TabPane>
                    <TabPane tabId="completed">
                        {activeTab === 'completed' && <CompletedApplications />}
                    </TabPane>
                </TabContent>
            </Container>
        </div>
    )
}

export default Applications
